import {PIXI} from '@colonist/pixi'
import {UIGameManager} from '../UIGameManager'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {UIHoverActionController} from './UIHoverActionController'
import {PieceTypes} from '@colonist/game-base-types'
import {getCardsForPiece} from '@colonist/game-card-types'
import {MechanicValidatorCityWall} from '@colonist/game-mechanic-validators'
import {MechanicCityWallState} from '@colonist/game-states'

export class UICityWallHoverActionController extends UIHoverActionController {
    private readonly validatorCityWall: MechanicValidatorCityWall

    constructor(uiGameManager: UIGameManager, cityWallState: MechanicCityWallState) {
        super(uiGameManager)
        this.validatorCityWall = new MechanicValidatorCityWall(this.uiGameManager.gameController.getPlayerValidators(), this.uiGameManager.gameController.mapValidator, cityWallState)
        this.isCornerAction = true
        this.resources = getCardsForPiece(PieceTypes.CityWall)
        this.action = (index: number) => this.uiGameManager.socketGameSend.confirmBuildCityWallSkippingSelection(index)
        this.uiGameManager.mapController.hoverController.registerTileCornerHoverAction(this)
    }

    getBankActionAmount(index: number): number {
        const cityWallPlayerState = this.validatorCityWall.getCityWallPlayerState(this.uiGameManager.gameController.myColor)
        return cityWallPlayerState.bankCityWallAmount
    }

    protected updateState() {
        const player = this.uiGameManager.gameController.getPlayerState(this.uiGameManager.gameController.myColor)
        const canPlaceCityWall = this.validatorCityWall.canPlayerPlaceCityWall(player.color)
        this.updateHoverLocations(canPlaceCityWall.validHoverLocations, canPlaceCityWall.canTakeAction)
        this.uiGameManager.mapController.hoverController.onHoverStateChange()
    }

    getTexture(index: number): PIXI.Texture {
        return UIGameSpriteHandler.getCityWallForPlayer(this.uiGameManager.gameController.myColor)
    }
}
